export const blockIconsCommunicationContactMail = (
	<span className='material-symbols-outlined'>contact_mail</span>
);
